import { connect } from 'react-redux';

import PriceBadgeContainer from './PriceBadgeContainer';
import { scrollToPriceAction } from '../../store/actions/view';
import { getSearcherFetching } from '../../store/selectors/searcher';

const mapStateToProps = (state) => ({
  fetching: getSearcherFetching(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClick: () => dispatch(scrollToPriceAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PriceBadgeContainer);
